// Copyright 2016 Sorama B.V.

export class WebRequestStatus {
    static statusUnauthorized = 401;
    static statusForbidden = 403;
    static statusNotFound = 404;
}
